import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetCustodyDailyPayoutRecords } from "@/api";
import type {
  GetCustodyDailyPayoutRecordsResponse,
  GetCustodyDailyPayoutRecordsRequest,
} from "@/api/types";
import { getToken } from "@/lib/auth";

const PAGE_SIZE = 100;

export function useGetCustodyDailyPayoutRecords(mergedOrderId?: string) {
  return useInfiniteQuery({
    queryKey: ["custodyDailyPayoutRecords", mergedOrderId ?? ""],
    queryFn: async ({
      pageParam,
    }): Promise<GetCustodyDailyPayoutRecordsResponse> => {
      const req: GetCustodyDailyPayoutRecordsRequest = {
        page: pageParam,
        pageSize: PAGE_SIZE,
      };
      if (mergedOrderId) req.mergedOrderId = mergedOrderId;
      const res = await ApiGetCustodyDailyPayoutRecords(req);
      console.log("ApiGetCustodyDailyPayoutRecords", res);
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const fetched = allPages.reduce(
        (sum, page) => sum + (page.records?.length ?? 0),
        0
      );
      if (fetched >= (lastPage.total ?? 0)) return undefined;
      return allPages.length + 1;
    },
    enabled: !!getToken(),
  });
}
